// Common configurations related to YourOrder scope.

// The flag to show whether the asin is returnable or not.
export const RETURNABLE_FLAG = Object.freeze({
  NOT_RETURNABLE: '0',
  RETURNABLE: '1'
});

// Order status
export const ORDER_STATUS = Object.freeze({
  PAID: 'PAID',
  PROCESSING: 'PROCESSING',
  DELIVERING: 'DELIVERING',
  DELIVERED: 'DELIVERED',
  FULFILLMENT: 'FULFILLMENT',
  UNFULFILLABLE: 'UNFULFILLABLE',
  NOSHIPMENT: 'NOSHIPMENT',
  CRETURNS: 'CRETURNS',
  RETURN: 'RETURN',
  CANCELLED: 'ORDER_CANCELLED',
  FRONT_END_PAID: 'front_end_paid',
  PROCESSING_WITH_SHIPMENT: 'processing_with_shipment',
  PROCESSING_WITHOUT_SHIPMENT: 'processing_without_shipment'
});

// Payment status
export const PAYMENT_STATUS = Object.freeze({
  NOT_PAID: 'NOT_PAID',
  PAID_APPROVED: 'PAID_APPROVED',
  REFUND_APPROVED: 'REFUND_APPROVED'
});

// Shipment status
export const SHIPMENT_STATUS = Object.freeze({
  INTERNATIONAL: 'INTERNATIONAL',
  UNDISPLAYED: 'UNDISPLAYED',
  DOMESTIC: 'DOMESTIC',
  DELIVERED: 'DELIVERED',
  IN_TRANSIT: 'IN_TRANSIT',
  DELAYED: 'DELAYED',
  DELIVERY_ATTEMPTED: 'DELIVERY_ATTEMPTED',
  OUT_FOR_DELIVERY: 'OUT_FOR_DELIVERY',
  AVAILABLE_FOR_PICKUP: 'AVAILABLE_FOR_PICKUP',
  UNDELIVERABLE: 'UNDELIVERABLE',
  RETURNING: 'RETURNING',
  RETURNED: 'RETURNED',
  CUSTOMER_ACTION: 'CUSTOMER_ACTION',
  EXPIRED: 'EXPIRED',
  UNKNOWN: 'UNKNOWN'
});

// Front end order status
export const FRONT_END_ORDER_STATUS = Object.freeze({
  KYC_ERROR: 'KYC_ERROR',
  EXPIRED: 'EXPIRED',
  WAITING_PAY: 'WAITING_PAY',
  SHIPMENT_EMPTY: 'SHIPMENT_EMPTY',
  WAITING_DELIVERY: 'WAITING_DELIVERY',
  DELIVERING: 'DELIVERYING',
  DELIVERED: 'DELIVERED',
  DELIVERY_FAILED: 'DELIVERY_FAILED',
  CRETURNS_RETURNING: 'CRETURNS_RETURNING',
  CRETURNS_REFUND: 'CRETURNS_REFUND',
  RETURNING: 'RETURNING',
  REFUNDING: 'REFUNDING',
  WAITING_CONFIRMATION: 'WAITING_CONFIRMATION',
  REFUND: 'REFUND',
  CANCEL: 'CANCEL'
});

// Front end order status mapping
export const FRONT_END_ORDER_STATUS_MAPPING = Object.freeze({
  KYC_ERROR: [ORDER_STATUS.CANCELLED],
  EXPIRED: [],
  WAITING_PAY: [ORDER_STATUS.CANCELLED],
  SHIPMENT_EMPTY: [],
  WAITING_DELIVERY: [
    ORDER_STATUS.PAID,
    ORDER_STATUS.PROCESSING_WITHOUT_SHIPMENT
  ],
  DELIVERING: [ORDER_STATUS.DELIVERING, ORDER_STATUS.PROCESSING_WITH_SHIPMENT],
  DELIVERED: [ORDER_STATUS.DELIVERED, ORDER_STATUS.FULFILLMENT],
  DELIVERY_FAILED: [ORDER_STATUS.UNFULFILLABLE],
  CRETURNS_RETURNING: [ORDER_STATUS.CRETURNS],
  CRETURNS_REFUND: [ORDER_STATUS.CRETURNS],
  RETURNING: [ORDER_STATUS.RETURN],
  REFUNDING: [ORDER_STATUS.RETURN],
  WAITING_CONFIRMATION: [ORDER_STATUS.FRONT_END_PAID],
  REFUND: [],
  CANCEL: [ORDER_STATUS.CANCELLED]
});

// Front end shipment status
export const FRONT_END_SHIPMENT_STATUS = Object.freeze({
  DELIVERING: 'DELIVERYING',
  DELIVERED: 'DELIVERYED',
  DELIVERY_FAILED: 'DELIVERY_FAILED',
  WAITING_DELIVERY: 'WAITING_DELIVERY',
  RETURNING: 'RETURNING',
  EXPIRED: 'EXPIRED',
  UNKNOWN: 'NOHANDLE'
});

// Front end shipment status mapping
export const FRONT_END_SHIPMENT_STATUS_MAPPING = Object.freeze({
  DELIVERING: [
    SHIPMENT_STATUS.IN_TRANSIT,
    SHIPMENT_STATUS.OUT_FOR_DELIVERY,
    SHIPMENT_STATUS.AVAILABLE_FOR_PICKUP,
    SHIPMENT_STATUS.DELIVERY_ATTEMPTED,
    SHIPMENT_STATUS.DELAYED
  ],
  DELIVERED: [SHIPMENT_STATUS.DELIVERED],
  DELIVERY_FAILED: [SHIPMENT_STATUS.UNDELIVERABLE],
  WAITING_DELIVERY: [SHIPMENT_STATUS.UNKNOWN, ORDER_STATUS.NOSHIPMENT],
  RETURNING: [SHIPMENT_STATUS.RETURNING],
  EXPIRED: [SHIPMENT_STATUS.EXPIRED],
  UNKNOWN: []
});

// Front end unusual asin status
const UNUSUAL_ASIN_STATUS = Object.freeze({
  CRETURNS_RETURNING: FRONT_END_ORDER_STATUS.CRETURNS_RETURNING,
  CRETURNS_REFUND: FRONT_END_ORDER_STATUS.CRETURNS_REFUND,
  CANCEL: FRONT_END_ORDER_STATUS.CANCEL,
  RETURNING: FRONT_END_ORDER_STATUS.RETURNING,
  REFUNDING: FRONT_END_ORDER_STATUS.REFUNDING,
  UNKNOWN: FRONT_END_SHIPMENT_STATUS.UNKNOWN,
  EXPIRED: FRONT_END_SHIPMENT_STATUS.EXPIRED
});

// return order text types
export const returnOrderText = Object.freeze({
  NOT_SUPPORT_NO_REASON_REFUND: 'NOT_SUPPORT_NO_REASON_REFUND',
  NOT_SUPPORT_REFUND: 'NOT_SUPPORT_REFUND'
});

// customer review from component
const CUSTOMER_REVIEW_FROM_COMPONENT = {
  CUSTOMER_REVIEW: 'customerReview', // customer Review page
  ORDER_LIST: 'orderList' // order list page
};

export default { CUSTOMER_REVIEW_FROM_COMPONENT };
